import { render, staticRenderFns } from "./FilesContextMenu.vue?vue&type=template&id=08b61a97&"
import script from "./FilesContextMenu.vue?vue&type=script&lang=js&"
export * from "./FilesContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports